
<div class="navigateprofile">
    <img src="../../../assets/Indietown_icons/login-logo.svg" style="margin-bottom: 30px; width: 122px;" alt="">
    Navigating back to profile!</div>
